import React from 'react';
import './embeds.css';

export default function ActionButton({ label, icon, onClick, variant = 'primary' }) {
  return (
    <button className={`embed-action-btn ${variant}`} onClick={onClick}>
      {icon && <span className="embed-action-icon" aria-hidden>{icon}</span>}
      <span>{label}</span>
    </button>
  );
}
